import React, { useContext } from 'react'

import { gql, useQuery } from '@apollo/client'
import { Redirect, useParams } from 'react-router-dom'
import { GraphPosition } from '@arcxgame/contracts/dist/arc-types/core'
import { Spinner } from 'src/components/Spinner'
import { useWeb3React } from '@web3-react/core'

import { ArcContext } from '../../contexts/ArcContext'

import './PositionPage.scss'
import { ManageExisting } from '../../components/Manage/ManageExisting'
import { ConnectWallet } from '../../components/ConnectWallet'

const GET_POSITION = gql`
  query Position($id: String) {
    position(id: $id) {
      id
      owner
      synth
      collateralAmountSign
      collateralAmountValue
      borrowedAmountSign
      borrowedAmountValue
    }
  }
`

export function PositionPage() {
  const { id } = useParams<{ id: string }>()
  const { account } = useWeb3React()
  const { getSynth, arc } = useContext(ArcContext)
  const {
    data: positionData,
    loading,
    error,
  } = useQuery(GET_POSITION, {
    variables: {
      id: id.toString(),
    },
    pollInterval: 5000,
  })

  if (!account) {
    return <ConnectWallet />
  }

  if (error || (!loading && !positionData)) {
    console.error('Error getting position', error, { positionData })
    return <Redirect to="/vaults" />
  }

  const position: GraphPosition = positionData?.position as GraphPosition
  const synth = position && getSynth(position.synth)

  if (loading || !synth || !arc) {
    return (
      <div className="page" style={{ height: 'auto' }}>
        <Spinner />
      </div>
    )
  }

  return (
    <div className="position page">
      <ManageExisting position={position} synth={synth} />
    </div>
  )
}
